import { render } from "./InputMasked.vue?vue&type=template&id=353cd906&ts=true"
import script from "./InputMasked.vue?vue&type=script&lang=ts"
export * from "./InputMasked.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__